import React, { Component } from 'react'
import { connect } from 'react-redux'
import { SelfieComponent } from '../components'
import { saveSelfie, resetSelfie } from '../actions'
import { updateRequestState, getRequestState } from '../../../shared/actions'
import { isEqual } from 'lodash'

class Selfie extends Component {
    constructor(props) {
        super(props)

        this.state = {
            step: 1,
            selfieImage: props.selfie,
            isCameraOn: false
        }
    }

    componentDidMount = () => {
        this.props.getRequestState()
        if (this.props.history.location.params && this.props.history.location.params.to === 'preview') {
            this.resetSelfie()
        } else if (this.state.selfieImage) {
            this.setState({ step: 2 })
        }
    }

    goToScreen = (key, params) => {
        if (this.props.history.location && this.props.history.location.params) {
            this.props.history.push(this.props.history.location.params.to)
        } else {
            this.props.history.push({
                pathname: key,
                params: params,
            })
        }
    }

    resetSelfie = () => {
        this.setState({ step: 1, selfieImage: '' })
        this.props.resetSelfie()
    }

    goBack = () => {
        if (this.state.step === 2) {
            this.resetSelfie()
        } else {
            this.props.history.replace("documents")
        }
    }

    captureImage = (image) => {
        this.setState({ step: 2, selfieImage: image })
    }

    handleChange = (key, value) => {
        this.setState({ [key]: value })
    }

    submit = () => {
        if (!isEqual(this.state.selfieImage, this.props.selfie)) {
            this.props.updateRequestState({
                upload: ['selfie'],
                state: "selfie_captured",
                data: {
                    selfie: this.state.selfieImage
                },
                nextRoute: 'idProof'
            })
        } else {
            this.goToScreen('idProof')
        }
    }

    render() {
        const { language, languageJSON } = this.props
        const { step, selfieImage, isCameraOn } = this.state
        return (
            <SelfieComponent
                step={step}
                isCameraOn={isCameraOn}
                goBack={this.goBack}
                goToScreen={this.goToScreen}
                language={language}
                languageJSON={languageJSON}
                selfieImage={selfieImage}
                captureImage={this.captureImage}
                submit={this.submit}
                handleChange={this.handleChange}
            />
        )
    }
}

const mapStateToProps = ({ language: { language, languageJSON }, selfie: { selfie } }) => ({
    language,
    selfie,
    languageJSON
})

const mapDispatchToProps = {
    saveSelfie,
    resetSelfie,
    updateRequestState,
    getRequestState
}

export default connect(mapStateToProps, mapDispatchToProps)(Selfie)

